// extracted by mini-css-extract-plugin
export default {"inputs":"EventLogsSearchBar_inputs__otP4a","searchIcon":"EventLogsSearchBar_searchIcon__KLBr6"};